<template>
  <div class="bg-white p-5">
    <el-form
      label-position="top"
      size="medium"
    >
      <el-form-item label="请选择广告系列类型">
        <el-radio-group
          :value="type"
          @input="(val) => onChange(val, 'type')"
        >
          <el-radio-button
            label="SEARCH"
            key="SEARCH"
            >搜索</el-radio-button
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="请选择推广目标">
        <el-radio-group
          :value="optimizationGoal"
          @input="(val) => onChange(val, 'optimizationGoal')"
        >
          <el-radio-button
            label=""
            key=""
            >购买</el-radio-button
          >
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: 'SEARCH',
    },
  },
  data() {
    return {
      type: 'SEARCH',
      optimizationGoal: '',
    };
  },
  created() {
    this.type = this.value || 'SEARCH';
  },
  methods: {
    onChange(val, key) {
      this[key] = val;
      if (key === 'type') {
        this.$emit('input', val);
      }
    },
    // 对外提供的验证方法
    validate() {
      if (!this.type) {
        return Promise.reject(new Error('请选择广告系列类型'));
      }
      return Promise.resolve(true);
    },
  },
};
</script>
